import { idDeOpcion } from './flows';

// «Cuánto vale lo que te libera» (An, 04/11: «no regalemos prompts»; y después: «6 horas mensuales no vende.
// Buscá lo que hablamos, lo usamos para REMAX»). Es el método de la propuesta de REMAX del 03/11
// (~/GUIA/seguimiento/archivos/remax/propuesta-economica-2026-11-03.md y el ítem del 03/11 en remax-ai-os.md):
// - supuesto pesimista: 50 minutos por día por persona, el 10 % de la jornada, para no prometer de más;
// - 20 días hábiles por mes (5 días × 4 semanas, la cuenta de REMAX);
// - la hora a ARS 10.000: lo que cuesta un administrativo de Comercio con cargas (An, 03/11, sesión de la oferta);
// - una persona a jornada completa: 8 h × 20 días = 160 h por mes.
// Lo que pone el cliente (An, 04/11: «el cuánto se reduce por día no lo puede poner el cliente; eso tiene que
// tener escenarios»): cuántas personas y cuántas horas por semana trabajan en promedio. Las horas siguen la
// escala de la jornada: 48 h es la de Comercio (CCT 130/75: 8 h diarias y 48 semanales, la que rige en locales y
// shoppings; An, 04/11: «no pongas máximo legal, jornada comercial»).
export const HORAS_SEMANA = [{ h: 20, texto: '20 h', nota: 'media jornada' }, { h: 40, texto: '40 h', nota: 'jornada de oficina' }, { h: 48, texto: '48 h', nota: 'jornada de comercio' }];
// Cuánto del tiempo de tareas se libera, por escenario (An, 04/11): pesimista 10 % (el supuesto de REMAX: 50 min
// de una jornada de 8 h), conservador 20 %, y uno donde la persona pone el porcentaje. No se le pregunta: es un
// filtro del resultado (An, 04/11: «no les preguntes cuánto tiempo libera, eso es un filtro en el resultado»).
export const ESCENARIOS = [{ id: 'pesimista', texto: 'Pesimista', pct: 10 }, { id: 'conservador', texto: 'Conservador', pct: 20 }, { id: 'propio', texto: 'Vos elegís', pct: null }];
export const PCT_PROPIO = { min: 1, max: 60, inicial: 30 };
export const SEMANAS_POR_MES = 4; // 20 días hábiles por mes, la cuenta de REMAX
// El valor hora lo pone la persona; lo que confirma se mide para conocer el valor hora promedio de quien
// visita (An, 04/11: «así vamos perfilando a nuestros clientes y la gente de la página»). Fuera de este rango no
// se toma como dato.
export const HORA_RANGO = { min: 1000, max: 500000 };

// Personas de arranque según lo que contó. 🟠 Mías (un punto dentro de cada rango), a validar por An.
const PERSONAS_POR_EQUIPO = { solo: 1, de2a5: 3, de6a20: 8, mas_de_20: 20 };

export const arranquePara = (collected = {}) => {
  const porEquipo = PERSONAS_POR_EQUIPO[idDeOpcion('ia_equipo', collected.equipo)];
  const personas = porEquipo || (collected.para === 'personal' ? 1 : 3);
  // Sin valor hora de arranque: lo pone la persona (An, 04/11: «que no tenga una hora de trabajo precalculada,
  // que lo tengas que poner»). 🟠 Arranca en 40 h y pesimista.
  return { personas, horas: 40, escenario: 'pesimista', pctPropio: PCT_PROPIO.inicial, hora: null };
};

export const pctDe = ({ escenario, pctPropio }) => ESCENARIOS.find(e => e.id === escenario)?.pct ?? pctPropio;

export const cuentaDe = (n) => {
  const horasSemana = (n.personas * n.horas * pctDe(n)) / 100;
  const pesosMes = n.hora ? Math.round((horasSemana * SEMANAS_POR_MES * n.hora) / 1000) * 1000 : null;
  // El resultado va en horas por semana, la misma medida con la que se cargan los datos (An, 04/11: «que no sean
  // jornadas por semana, sino horas»). totalSemana es todo lo que trabaja el equipo: la barra muestra la parte liberada.
  return { porPersona: (n.horas * pctDe(n)) / 100, horasSemana, totalSemana: n.personas * n.horas, horasMes: horasSemana * SEMANAS_POR_MES, pesosMes };
};
